import type { TCreateSlice } from "@/store";

type TStateUiSettings = {
    newUiEnabled: boolean;
};

type TActionsPublic = {
    setNewUiEnabled: (enabled: boolean) => void;
};

export type TSliceUiSettings = TStateUiSettings & TActionsPublic;

const readNewUiEnabledFromStorage = (): boolean => {
    try {
        return window.localStorage.getItem("newUiEnabled") === "true";
    } catch {
        return false;
    }
};

export const createSliceUiSettings: TCreateSlice<
    TSliceUiSettings,
    Record<string, never>
> = () => set => ({
    newUiEnabled: readNewUiEnabledFromStorage(),
    setNewUiEnabled: (enabled: boolean) => {
        set({ newUiEnabled: enabled }, false, "uiSettings/setNewUiEnabled");
    },
});
